import { ApolloClient, ApolloProvider as AP, HttpLink, InMemoryCache } from '@apollo/client';
import { FC, useMemo } from 'react';
import { ulid } from 'ulid';
import { useDevMode } from './DevMode';

// singleton cache to persist across apis
const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        agent: {
          read(_, { args, toReference }) {
            return toReference({
              __typename: 'Agent',
              id: args?.id,
            });
          },
        },
      },
    },
  },
});

export const apolloClient = new ApolloClient({
  cache,
  link: new HttpLink({
    uri: process.env.REACT_APP_GRAPHQL_ENDPOINT,
    headers: {
      'X-Search-ID': ulid(),
    },
  }),
});

export const ApolloProvider: FC = ({ children }) => {
  const devMode = useDevMode();
  const sessionId = useMemo(() => ulid(), []);
  const client = useMemo(
    () =>
      new ApolloClient({
        cache,
        link: new HttpLink({
          uri: devMode.apiOverride || process.env.REACT_APP_GRAPHQL_ENDPOINT,
          headers: {
            'X-Search-ID': sessionId,
          },
        }),
      }),
    [devMode.apiOverride, sessionId]
  );

  return <AP client={client}>{children}</AP>;
};
